/*
 * Public API Surface of ngx-code-highlight
 */

export * from './ngx-code-highlight.component';
export * from './ngx-code-highlight.module';
